<p-dropdown
  [options]="filteredItems"
  [(ngModel)]="selectedItem"
  optionLabel="name"
  [filter]="true"
  [showClear]="true"
  [placeholder]="placeholder"
  styleClass="w-10rem"
  (onChange)="changeSelectedItem($event.value)"
  (onClear)="clearSelection()"
  >
</p-dropdown>
